(function () {
    window.addEventListener('load', function () {
        var closeButton = document.querySelector('#main>section.suggestedCountryBanner .closeButton');
        var viewAllText = document.querySelector('#main>section.suggestedCountryBanner .viewAllText');
        var state = document.getElementById('suggestedCountryBannerState');

        if (closeButton) {
            closeButton.addEventListener('click', function () {
                setCookieAndCloseBanner(state);
            });

        }
        if (viewAllText) {
            viewAllText.addEventListener('click', function () {
                setCookieAndCloseBanner(state);
            });
        }

        function setCookieAndCloseBanner(element) {
            element.checked = false;
            document.cookie = "closeCountry=1";
        }

        //Close .suggestedCountryBanner if we have the closing cookie set. This is a per session fix.
        var cookie_ = document.cookie;
        if (state && cookie_.indexOf('closeCountry') > -1) {
            state.checked = false;
        }

    }, false);
})();